import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgFaIconComponent } from './fa-icon/fa-icon.component';


@NgModule({
	declarations: [
		NgFaIconComponent
	],
	imports: [
		CommonModule
	],
	exports: [
		NgFaIconComponent
	]
})
export class NgStylingComponentsModule {}
